import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/security/cwe-lookup/top25/Top25Client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/ToolLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
